module.exports = __webpack_public_path__ + "static/af-tou-8a75afbab99151d74ec1852d052a916c.pdf";